require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-uitkijktoren-tureluur.json") })
        }
      }, "path---projecten-uitkijktoren-tureluur");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-uitkijktoren-tureluur!./.cache/json/projecten-uitkijktoren-tureluur.json
// module id = 451
// module chunks = 231608221292675